import { Link } from 'react-router-dom';
import { Section } from '../components';

export const NotFound: React.FC = () => {
  return (
    <Section background="black" className="min-h-[60vh] flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-6xl font-black text-gorillaGold mb-4">404</h1>
        <p className="text-2xl text-primary mb-8">Page Not Found</p>
        <Link
          to="/"
          className="text-gorillaGold hover:text-gorillaGoldAlt underline transition-colors"
        >
          Return Home
        </Link>
      </div>
    </Section>
  );
};
